import { middleSidePartOfWeb, topSidePartOfWeb, topSidePartOfWebWithJoint2 } from './parts/sideParts'
import { verticalPartsOfWeb, verticalPartsOfWebWithCenterStitch } from './parts/verticalParts'

export const crossWeb = (ctx: CanvasRenderingContext2D, webColor: string, web2Color: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // ウェブ_縦
  verticalPartsOfWeb(ctx, web2Color, stitchColor)
  // ウェブ先端
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // ウェブ_横＿中間
  middleSidePartOfWeb(ctx, webColor, stitchColor, 5, 10)
}

export const crossWebCenterStitch = (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  web2Color: string,
  laceColor: string,
  stitchColor: string
): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // ウェブ_縦
  verticalPartsOfWebWithCenterStitch(ctx, web2Color, stitchColor)
  // ウェブ先端
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // ウェブ_横＿中間
  middleSidePartOfWeb(ctx, webColor, stitchColor, 5, 10)
}

export const crossJointWeb = (ctx: CanvasRenderingContext2D, webColor: string, web2Color: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // ウェブ_縦
  verticalPartsOfWeb(ctx, webColor, stitchColor)

  // stitchここから
  ctx.lineWidth = 1.1
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // 縦＿左
  ctx.moveTo(259, 204) // 上
  ctx.quadraticCurveTo(281, 276, 314, 339) // 下
  // 縦＿右
  ctx.moveTo(286, 166) // 上
  ctx.quadraticCurveTo(300, 238, 332, 305) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()

  // ウェブ先端
  topSidePartOfWebWithJoint2(ctx, webColor, web2Color, laceColor, stitchColor)
  // ウェブ_横＿中間
  middleSidePartOfWeb(ctx, web2Color, stitchColor, 17, 32)
}
